import React from 'react';
import { Descriptions } from 'antd';

const fieldLabels = {
  personalAccount: 'Лицевой счет',
  fullName: 'ФИО',
  phone: 'Телефон',
  email: 'E-mail',
  address: 'Адрес',
  branch: 'Филиал',
  serviceDepartment: 'Обслуживающее отделение',
  appealSubject: 'Тема обращения',
  serviceText: 'Текст обслуживания',
  appealText: 'Текст обращения',
  applicantType: 'Тип заявителя',
};

function ShowText({ item }) {
  if (!item) return <div>Нет данных</div>;

  // Если item - объект (extraData)
  if (typeof item === 'object' && !Array.isArray(item)) {
    return (
      <Descriptions column={1} bordered size="small">
        {Object.entries(item).map(([key, value]) => (
          <Descriptions.Item
            key={key}
            label={<strong>{fieldLabels[key] || key}</strong>}
          >
            {value || '-'}
          </Descriptions.Item>
        ))}
      </Descriptions>
    );
  }

  // Обратная совместимость: если item - строка (старый формат)
  if (typeof item === 'string') {
    try {
      const data = JSON.parse(item);
      return (
        <Descriptions column={1} bordered size="small">
          {data.map((dItem) => (
            <Descriptions.Item
              key={dItem.title}
              label={<strong>{dItem.title}</strong>}
            >
              {dItem.value || '-'}
            </Descriptions.Item>
          ))}
        </Descriptions>
      );
    } catch (e) {
      return <div style={{ padding: '16px' }}>{item}</div>;
    }
  }

  return <div>Нет данных</div>;
}

export default ShowText;
